/**
 *
 * errorWatch
 *
 * Creates properties that check for important vendor scripts that Iterable uses
 *
 * Creates an event that appends errors to the error log
 *
 */

class ErrorWatch{

  constructor(){
    this.has = Object.prototype.hasOwnProperty;
    this.watchList = {
      googleAnalytics : 'ga', //google analytics
      Munchkin : 'Munchkin', //munchkin
      segment : 'analytics', //segment
      MktoForms2 : 'MktoForms2' //marketo forms
    };

    try{
      this.events();
      this.checkForScripts();
    }catch(e){
      console.log(e);
    }

  }

  /**
   * checks for the important vendor scripts
   */
  checkForScripts(){
    //check if ITBL object exists
    if( !(window.ITBL) ){
      window.ITBL = {};
    }

    //setup error object
    if( !(this.has.call( window.ITBL, 'errorWatch' ) ) ){
      window.ITBL.errorWatch = {
        errors: []
      };
    }

    //get browser
    window.ITBL.errorWatch.browser = window.navigator.userAgent;

    //check operating system
    window.ITBL.errorWatch.os = window.navigator.appVersion;

    //loop through the const object and check for these functions in the window object
    Object.entries( this.watchList ).forEach( ([key, val])=>{

      window.ITBL.errorWatch[key] = this.has.call( window, val );

    } );

  }

  /**
   * adds all events to be watched
   */
  events(){

    window.onerror = (message, url, line, col, error)=>{

      //these are the error messages we are going to watch for, if there is no match then we exist the function
      //check to make sure the error array is in the ITBL.errorWatch object
      if( !(this.has.call( window.ITBL.errorWatch, 'error' ) )  ){

        window.ITBL.errorWatch.errors = [];

        window.ITBL.errorWatch.errors.push( String( error ) );

      }else{
        window.ITBL.errorWatch.errors.push( String( error ) );

      }

    };

  }

}

window.addEventListener('load', ()=>{

  try{
    new ErrorWatch();

  }catch (e) {
    console.log( e );
  }

});
